<template>
  <div id="modalEvent">
    <Modal v-show="isModalVisible" @close="closeModal">
      <!-- <template v-slot:header>
      
      </template> -->

      <template v-slot:body>

      

        <img
          src="./../../assets/popup/q1.jpg"
          alt=""
          width="100%"
          height="auto"
        />
 
      
    
      
      </template>

      <!-- <template v-slot:footer>
       
      </template> -->
    </Modal>
  </div>
</template>

<script>
// import $ from "jquery";
import Modal from "./modal.vue";
export default {
  name: "modalEvent",
  mounted() {
    // $('#exampleModal').modal();
  },
  components: {
    Modal,
  },
  data() {
    return {
      isModalVisible: true,
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
     close() {
      this.$emit("close");
    },
    data() {
      return {
        showModal: true,
      };
    },
  },
};
</script>

<style scoped>
img{
  border-radius: 5%;
}

.image-wrapper {
  position: relative;        /* ให้ container เป็นจุดอ้างอิง */
  display: inline-block;
  width: 100%;
}

.popup-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
}

.btn-close-on-image {
  position: absolute;        /* ทำให้ปุ่มทับบนภาพ */
  top: 10px;                 /* ระยะจากขอบบน */
  right: 10px;               /* ระยะจากขอบขวา */
  background: rgba(0, 0, 0, 0.6);  /* พื้นหลังโปร่งใส */
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s;
}

.btn-close-on-image:hover {
  background: rgba(0, 0, 0, 0.8);
}
</style>
